import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import "./Message.css";
import moment from "moment";

function Message({ id, data }) {
  const [user] = useAuthState(auth);
  return (
    <div className="message_box">
      {user.email === data.user ? (
        <p className="right">
          {data.message}
          {data.timestamp ? (
            <span className="timestamp">
              <br />
              {moment(data.timestamp.toDate()).format("LT")}
            </span>
          ) : (
            <span>...</span>
          )}
        </p>
      ) : (
        <p className="left">
          {data.message}
          {data.timestamp ? (
            <span className="timestamp">
              <br />
              {moment(data.timestamp.toDate()).format("LT")}
            </span>
          ) : (
            <span>...</span>
          )}
        </p>
      )}
    </div>
  );
}

export default Message;
